export const API_BANNERS_TRANSLATIONS_FIELDS = [
    'banners.translations.banners_id',
    'banners.translations.languages_code',
    'banners.translations.title',
    'banners.translations.description',
    'banners.translations.button_link'
];
